import * as React from "react";
import {CurrencyManager} from "../Managers/CurrencyManager";
import {CSSProperties} from "react";


export class Price extends React.Component<PriceProps, PriceState> {
    static defaultProps: Partial<PriceProps> = {
        SaleAmount:0
    };

    constructor(props: PriceProps) {
        super(props);
        this.state = {};
    }

    public render() {
        let salePrice=this.props.SaleAmount;
        if(isNaN(salePrice))
            salePrice=0;

        if(salePrice>0)
            return(
                <span className={"price rn-price "} style={this.props.style}>
                    <del>
                        <span className={'rn-original-price amount'} dangerouslySetInnerHTML={{__html:CurrencyManager.FormatPrice(this.props.Amount)}}/>
                    </del>
                    <ins style={{marginLeft:5}}>
                         <span className={'amount'} dangerouslySetInnerHTML={{__html:CurrencyManager.FormatPrice(salePrice)}}/>
                    </ins>
                </span>
            )
        return (
            <span className={"price rn-price "}  style={this.props.style}>
                <span className={'amount'} dangerouslySetInnerHTML={{__html:CurrencyManager.FormatPrice(this.props.Amount)}}/>
            </span>
        )
    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface PriceProps {
    Amount:number;
    SaleAmount:number;
    style:CSSProperties;
}

interface PriceState {

}

//#endregion "My Region"